import { CircularProgress } from '@mui/material';
import { DataGrid, GridColDef, GridSelectionModel } from '@mui/x-data-grid';
import { Software } from '../../api/api-generated';
import { useFindAllSoftwareQuery } from '../../api/api-hooks';
import { Item } from '../../utils/sharedTypes';

interface Props {
  setSelectedTypes: React.Dispatch<React.SetStateAction<Item[]>>;
}

const SoftwareTypesTable = ({ setSelectedTypes }: Props) => {
  const { data: types } = useFindAllSoftwareQuery({});
  if (types === undefined) return <CircularProgress></CircularProgress>;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'type', headerName: 'Type Name', width: 200 },
  ];
  const rows = types.map((item: Software) => ({
    ...item,
  }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedTypes(types.filter((type) => model.includes(type.id)));
  };
  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
      />
    </div>
  );
};

export default SoftwareTypesTable;
